const ServiceCard = ({ service }) => {
  if (!service) return null;

  const { id, title, description, icon, color } = service;

  return (
    <div
      className={`bg-white rounded-2xl shadow-md hover:shadow-xl p-6 border border-gray-100 transition-all duration-300 hover:-translate-y-1`}
    >
      {/* Icon in gradient circle using service.color */}
      <div
        className={`w-14 h-14 mb-4 rounded-2xl bg-gradient-to-br ${color} flex items-center justify-center text-white`}
      >
        {icon}
      </div>

      <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>

      <p className="text-gray-600 text-sm mb-4">
        {description}
      </p>

      {/* Optional small ID / tag */}
      <div className="text-xs text-gray-400">
        ID: <span className="font-mono">{id}</span>
      </div>
    </div>
  );
};

export default ServiceCard;
